import { useRouter } from 'next/router'
import { TypeVariationContainerPersonalization } from '@lib/types/variation-container-personalization'
import { matchPersonalizationCriteria } from './personalization-criteria-matcher'

/**
 * Find the matching variation based on the personalization criteria
 */
export function usePersonalization(content: TypeVariationContainerPersonalization) {
  const router = useRouter()

  const personalization = content.fields.variations.find((variation) => {
    return matchPersonalizationCriteria(variation.fields.criteria, router.query)
  })

  return personalization ? personalization.fields.component : content.fields.fallback
}
